exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".wfeList[data-v-6d6e3c6c]{background-color:purple;color:#fff;margin:\"0 auto\";text-align:center}.textCenter[data-v-6d6e3c6c]{text-align:center;margin:0 auto}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6d6e3c6c","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./src/pages/Home.vue
// module id = 78
// module chunks = 0